
import { Component, Vue } from 'vue-property-decorator';
import { 确认状态 } from '@/store/confirmState';

@Component({})
export default class Confirm extends Vue {
    get 标题() {
        return 确认状态.确认?.标题;
    }
    get 内容() {
        return 确认状态.确认?.内容;
    }
    get 确认文本() {
        return 确认状态.确认?.确认文本;
    }
    get 取消文本() {
        return 确认状态.确认?.取消文本;
    }
    get visibleDialog() {
        return 确认状态.确认 !== null;
    }

    confirm(): void {
        确认状态.确认?.resolve(true);
    }
    abort(): void {
        确认状态.确认?.resolve(false);
    }

    get color() {
        if (!确认状态.确认) return '';
        switch (确认状态.确认.类型) {
            case '信息':
                return 'primary';
            case '成功':
                return 'success';
            case '警告':
                return 'warning';
            case '错误':
                return 'error';
            default:
                return '';
        }
    }
}
